import { useSelector } from 'react-redux';
import { useLocation } from '@app/router';
import { getCustomerMarketCountry } from '@app/redux/customer/selectors';
import { isValidCountryCode } from '@app/countries/utils';

const DEFAULT_COUNTRY_CODE = 'US';
const useCountry = () => {
  const {
    query: { country },
  } = useLocation();

  const countryCode = isValidCountryCode(country as string) && country;
  const reduxCountryCode = useSelector(getCustomerMarketCountry);

  return (countryCode || reduxCountryCode || DEFAULT_COUNTRY_CODE) as string;
};

export default useCountry;
